import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function LineChart() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [colors.ReactifyChartColor1],
        chart: {
          id: "basic-line"
        },
        xaxis: {
          categories: ["Sun", "Mon", "Tue", "Thur", "Fri", "Sat"]
        }
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            plotOptions: {
              bar: {
                horizontal: false
              }
            }
          }
        }
      ],
      series: [
        {
          name: "Sales",
          data: [20, 30, 44, 30, 50, 45]
        }
      ]
    }),
    []
  );

  return (
    <Chart options={options} series={series} type="line" width="100%" />
  );
}

export default LineChart;
